import React, { useRef } from "react";
import { CloudUpload } from 'lucide-react';
import { Eye, Info } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { cn } from "@/utils/shadcn-utils"

interface FileUploadInputProps {
  title: string;
  name: string;
  showModelDoc?: boolean;
  onChange: (file: File | null) => void;
  onBlur?: () => void;
  value?: File | string;
  mimes?: string;
  className?: string;
  tooltipText?: string;
}

const FileUploadInput: React.FC<FileUploadInputProps> = ({
                                                           title,
                                                           name,
                                                           showModelDoc = false,
                                                           onChange,
                                                           onBlur,
                                                           value,
                                                           mimes = "application/pdf",
                                                           className,
                                                           tooltipText = "Formats supportés: PDF, PNG, JPEG. Taille max: 2MB",
                                                         }) => {
  const fileNameRef = useRef<HTMLHeadingElement>(null);

  const showDocName = (e: React.ChangeEvent<HTMLInputElement>) => {
    const fileName =
      e.target.files?.[0]?.name ||
      "Cliquez pour choisir un fichier ou faites-le glisser ici";

    if (fileNameRef.current) {
      fileNameRef.current.textContent = fileName;
    }

    onChange(e.target.files[0]);
  };

  const getDisplayFileName = () => {
    if (typeof value === "string" && value) {
      // Si c'est une URL ou un chemin
      return value.split("/").pop() || value;
    }
    return "Cliquez pour choisir un fichier ou faites-le glisser ici";
  };

  const getSupportedFormats = () => {
    if (mimes === "application/pdf") return "PDF";
    if (mimes.includes("image")) return "PNG, JPEG, JPG, WEBP, SVG";
    return "PDF, Images";
  };

  return (
    <div className={cn("flex flex-col gap-2.5", className)}>
      {/* Label avec tooltip */}
      <div className="flex items-center gap-2.5 w-full">
        <span className="text-sm font-medium">{title}</span>
        {/*<TooltipProvider>*/}
        {/*  <Tooltip>*/}
        {/*    <TooltipTrigger asChild>*/}
        {/*      <button type="button" className="cursor-help">*/}
        {/*        <Info className="h-4 w-4 text-muted-foreground hover:text-foreground transition-colors" />*/}
        {/*      </button>*/}
        {/*    </TooltipTrigger>*/}
        {/*    <TooltipContent>*/}
        {/*      <p className="max-w-xs">{tooltipText}</p>*/}
        {/*    </TooltipContent>*/}
        {/*  </Tooltip>*/}
        {/*</TooltipProvider>*/}
      </div>

      {/* Zone d'upload */}
      <label
        htmlFor={name}
        className="border border-dashed border-focus rounded-md p-2.5 flex gap-5 cursor-pointer hover:bg-accent/50 transition-colors"
      >
        {/* Icône d'upload */}
        <div className="border-r border-text-nonFocus pr-5 pl-5 py-5 flex items-center justify-center">
          <CloudUpload size={35} className="text-text-nonFocus" />
        </div>

        {/* Informations d'upload */}
        <div className="flex flex-col justify-center gap-1.5 flex-1">
          <h3 ref={fileNameRef} className="text-[15px] font-medium">
            {getDisplayFileName()}
          </h3>
          <p className="text-text-nonFocus text-xs">
            Formats supportés: {getSupportedFormats()}
          </p>
          <p className="text-text-nonFocus text-xs">Taille maximale: 2MB</p>
        </div>

        {/* Input caché */}
        <input
          className="hidden"
          type="file"
          id={name}
          name={name}
          accept={mimes}
          onChange={showDocName}
          onBlur={onBlur}
        />
      </label>

      {/* Lien "Voir un exemple" */}
      {showModelDoc && (
        <button
          type="button"
          className="flex items-center gap-2 text-sm text-primary hover:underline self-start"
        >
          <span>Voir un exemple</span>
          <Eye className="h-4 w-4" />
        </button>
      )}
    </div>
  );
};

export default FileUploadInput;